<template>
  <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
    <template v-slot:activator="{ on }">
      <v-text-field :value="displayValue" :label="label" :placeholder="label" prepend-icon="event" readonly v-on="on" @change="sync" />
    </template>
    <v-date-picker v-model="value" no-title scrollable locale="ru-ru">
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="menu = false">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import DefaultField from './default'

export default {
  mixins: [DefaultField],
  data: () => ({
    menu: false,
    value: 'date field',
  }),
  computed: {
    displayValue () {
      if (!this.value) {
        return ''
      }
      let date = new Date(this.value)
      return date.toLocaleDateString('ru', {
        year: 'numeric',
        month: 'long',
        day: '2-digit'
      })
    }
  }
}
</script>
